<div class="btn-group">
  <button
    type="button"
    class="btn btn-secondary dropdown-toggle btn-sm ml-xl-5 pl-3 py-2 springBtn"
    (click)="openSiteModal()"
  >
    {{ sharedData?.selectedSite?.siteName || ("SELECT_SITE" | translate) }}
    &nbsp;
    <img src="assets/svg/ico-chevron-down-outline.svg" />
  </button>
  <div id="site-toggle" class="dropdown-menu dropdown-menu-right">
    <div class="triangle-with-shadow">
      <div class="rectangle">
        <div class="inner">
          {{
            sharedData?.selectedSite?.siteName || ("SELECT_SITE" | translate)
          }}&nbsp;
          <img src="assets/svg/ico-chevron-down-outline.svg" />
        </div>
      </div>
    </div>
  </div>
</div>
